<template>
  <div>
    <Button
      style="margin-bottom: 20px;"
      type="primary"
      @click="addOpeationBtnClick"
      >操作录入</Button
    >
    <Table
      class="subTable"
      border
      :columns="pageCompColumns"
      size="small"
      stripe
      :data="pageCompDataSource"
      disabled-hover
      row-key="id"
      ref="pageComptableRef"
    >
    </Table>
    <div style="margin: 10px; overflow: hidden">
      <div style="float: right">
        <Page
          show-total
          show-sizer
          :total="pageCompCount"
          :current="filter.pageIndex"
          :page-size="filter.pageSize"
          :page-size-opts="[5, 10, 15, 20]"
          @on-change="pageCompChangePage"
          @on-page-size-change="pageCompSizeChange"
        ></Page>
      </div>
    </div>
    <Modal
      v-model="pageCompFormDisplayStatus"
      title="操作录入"
      class="createModalClass"
    >
      <Form
        label-position="left"
        :label-width="100"
        :model="pageCompFormValidate"
        ref="pageCompFormValidate"
        :rules="pageCompFormRuleValidate"
      >
        <FormItem label="页面控件名称:" prop="componentName">
          <Input
            placeholder="请输入页面控件名称"
            v-model="pageCompFormValidate.componentName"
          ></Input>
        </FormItem>
        <FormItem label="页面控件编码:" prop="componentCode">
          <Input
            placeholder="请输入页面控件编码"
            v-model="pageCompFormValidate.componentCode"
          ></Input>
        </FormItem>
        <FormItem label="规则状态:" prop="componentStatus">
          <Select v-model="pageCompFormValidate.componentStatus">
            <Option
              v-for="item in pageCompometStatusList"
              :value="item.value"
              :key="item.value"
              >{{ item.label }}</Option
            >
          </Select>
        </FormItem>
        <FormItem>
          <Button
            type="primary"
            @click="pageCompomentHandleSubmit('pageCompFormValidate')"
            >确认</Button
          >
          <Button @click="poppageCompomentCreateMoal" style="margin-left: 8px"
            >取消</Button
          >
        </FormItem>
      </Form>
      <template #footer>
        <div style="height: 0px;"></div>
      </template>
    </Modal>
  </div>
</template>

<script>
import { getPageCompColumns } from '../config';
import { mapActions, mapMutations, mapState } from 'vuex';
// import getPermissionMixin from '@/mixins/getPermissionMixin';

const addOpeationURL = '/v1/funcMenu/pageComponent';
export default {
  props: {
    selectedMenuObj: {
      type: Object,
      default: {}
    },
    currentSystem: {
      type: String,
      default: ''
    }
  },
  // mixins: [getPermissionMixin],
  watch: {
    selectedMenuObj: {
      deep: true,
      handler(newValue, oldValue) {
        this.refreshPageCompent();
      }
    }
  },
  methods: {
    ...mapMutations('menuManage', ['SAVE_STATE']),
    ...mapActions('menuManage', ['getUserPermission', 'getPageCompList']),
    // callBack(res) {
    //   const pageArr =
    //     res.pageComponentMap == null
    //       ? []
    //       : res.pageComponentMap[this.tableName] || [];
    //   // const noShowPageArr = pageArr.map(item => item.colName);
    //   // 权限在外面控制
    //   const noShowPageArr = [];
    //   this.pageCompColumns = getPageCompColumns(
    //     {
    //       deletePageCompBtnClick: this.deletePageCompBtnClick,
    //       editPageCompBtnClick: this.editPageCompBtnClick
    //     },
    //     noShowPageArr
    //   );
    // },
    pageCompomentHandleSubmit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.pageCompFormValidate.appId = this.currentSystem;
          this.pageCompFormValidate.funcMenuId = this.selectedMenuObj.id;
          const parms = this.pageCompFormValidate;
          if (this.pageCompentOperate == 0) {
            // 操作录入
            this.$ajax.post(addOpeationURL, parms).then(res => {
              const { data } = res;
              if (data.code == 200) {
                this.$Message.success(data.msg);
                this.pageCompFormDisplayStatus = false;
                this.refreshPageCompent();
              }
            });
          } else if (this.pageCompentOperate == 1) {
            // 操作修改
            this.$ajax
              .put(`${addOpeationURL}/${this.currentPageComp.id}`, parms)
              .then(res => {
                const { data } = res;
                if (data.code == 200) {
                  this.$Message.success(data.msg);
                  this.pageCompFormDisplayStatus = false;
                  this.refreshPageCompent();
                }
              });
          }
        } else {
          this.$Message.error('所填信息异常');
        }
      });
    },
    poppageCompomentCreateMoal() {
      this.pageCompFormDisplayStatus = false;
    },
    clearPageCompomentForm() {
      this.pageCompFormValidate.componentCode = '';
      this.pageCompFormValidate.componentName = '';
      this.pageCompFormValidate.componentStatus = 1;
    },
    pageCompChangePage(page) {
      this.filter.pageIndex = page;
      this.getPageCompList({
        funcMenuId: this.selectedMenuObj.id,
        filter: this.filter
      });
    },
    pageCompSizeChange(size) {
      this.filter.pageSize = size;
      this.filter.pageIndex = 1;
      this.getPageCompList({
        funcMenuId: this.selectedMenuObj.id,
        filter: this.filter
      });
    },
    deletePageCompBtnClick(row) {
      this.$Modal.confirm({
        title: '提示',
        content: '是否删除该菜单？',
        loading: true,
        cancelText: '取消',
        onOk: () => {
          this.$ajax
            .delete(`/v1/funcMenu/pageComponent/${row.id}`)
            .then(res => {
              this.$Modal.remove();
              const { data } = res;
              if (data.code == 200) {
                this.$Message.success(data.msg);
                this.refreshPageCompent();
              } else {
                this.$Message.error(data.msg);
              }
            });
        }
      });
    },
    editPageCompBtnClick(row) {
      this.pageCompFormDisplayStatus = true;
      this.pageCompentOperate = 1;
      this.pageCompFormValidate.componentCode = row.componentCode;
      this.pageCompFormValidate.componentName = row.componentName;
      this.pageCompFormValidate.componentStatus = row.componentStatus;
      this.pageCompFormValidate.funcMenuId = this.selectedMenuObj.id;
      this.currentPageComp = row;
    },
    refreshPageCompent() {
      this.filter.pageIndex = 1;
      this.filter.pageSize = 10;
      this.getPageCompList({
        funcMenuId: this.selectedMenuObj.id,
        filter: this.filter
      });
    },
    addOpeationBtnClick() {
      this.clearPageCompomentForm();
      this.pageCompentOperate = 0;
      this.pageCompFormDisplayStatus = true;
    }
  },
  data() {
    return {
      tableName: 'pageCompomentsList',
      pageCompentOperate: 0,
      pageCompFormDisplayStatus: false,
      pageCompColumns: getPageCompColumns(
        {
          deletePageCompBtnClick: this.deletePageCompBtnClick,
          editPageCompBtnClick: this.editPageCompBtnClick
        },
        []
      ),
      // 页面控件权限
      filter: {
        pageIndex: 1,
        pageSize: 10
      },
      pageCompFormValidate: {
        appId: '',
        componentCode: '',
        componentName: '',
        componentStatus: 1,
        funcMenuId: ''
      },
      pageCompFormRuleValidate: {
        componentCode: [
          { required: true, message: '页面控件编码未填写', trigger: 'blur' }
        ],
        componentName: [
          { required: true, message: '页面控件名称未填写', trigger: 'blur' }
        ],
        componentStatus: 0,
        funcMenuId: { require: false }
      },
      pageCompometStatusList: [
        { label: '禁用', value: 0 },
        { label: '隐藏', value: 1 }
      ]
    };
  },
  computed: {
    ...mapState('menuManage', ['pageCompDataSource', 'pageCompCount'])
  }
};
</script>

<style scoped></style>
